import Base from '../../base';

export default class Default extends Base {
  init() {
    //Bail unless we are on product page
    if(this.d.template.indexOf('product') == -1) return;

    //Initialise 
    this.bus.$on('vue/loaded', (d) => {this.initVariant();});
    this.bus.$on('vue/loaded', (d) => {this.saveProduct();});
    this.bus.$on('vue/loaded', (d) => {this.initRelated();});

    this.bus.$on('product/buy', (d)  => {this.buy(d);});
    this.bus.$on('cart/item/adding', (d) => {this.cartItemAdding();});
    this.bus.$on('cart/item/added', (d)  => {this.cartItemAdded();});
  }

  initVariant() {
    //Select first variant (this could be first variant in stock)
    var variant = _.find(this.d.product.variants, (v) => {
      return v.available == true;
    });

    if(!variant) variant = this.d.product.variants[0];



    // if(this.d.product.variants.length == 1){
      //Set variant
      this.s.product.selected_variant = _.clone(variant);
      //Set options
      this.s.product.selected_options = _.clone(variant.options);
    // }
  }

  saveProduct() {
    this.ls.last_product = this.s.product;
  }

  buy(d) {
    var variant_id = this.s.product.selected_variant.id;
    var quantity   = this.s.product.selected_quantity;

    //Letters
    var has_letters     = _.includes(this.d.product.tags, 'option-letters');
    var selected_letter = this.s.product.selected_letter;

    var valid = true;
    if(typeof(variant_id) == 'undefined') valid = false;

    //Handle signet rings
    if(has_letters) {
      //Validate unselected letter
      if(!selected_letter) valid = false;
    }

    if(valid) {
      this.s.product.error = false;
      this.bus.$emit('cart/item/add', {id:variant_id,quantity:quantity, letter: selected_letter});
    } else {
      this.s.product.error = "Please make a selection";
    }
  }

  cartItemAdding() {
    this.s.cart.current_action = "adding";
  }

  cartItemAdded() {
    this.s.cart.current_action = "added";
    this.s.header.cart_active  = true;
    setTimeout(() => {
      this.s.cart.current_action = "";
    }, 2000);
  }

  initRelated() {
    //Search for related products based on tag
    var tags = this.d.product.tags;
    var tag  = _.filter(tags, (t) => {
      return (t.indexOf('related-') !== -1);
    })[0];

    if(!tag) return; //No point searching without tag
    var handle = tag.replace('related-','');

    this.u.shopify.products.collection({
      handle: handle,
      callback: (products) => {
        //Filter out the current product, because we don't need it
        var related = [];
        if(products.length >= 1) {
          //Remove current product from list
          this.s.product.related = this.formatRelated(products);
        }
      }
    });
  }

  formatRelated(products, include_self = false) {
    return _.chain(products)
      .filter((p) => {
        return (include_self) ? true : p.id !== this.d.product.id
      })
      .map((p) => {
        p.image_size = this.v.products.getResize(p);
        return p;
      })
      .shuffle()
      .slice(0,4)
      .value();
  }
} 